module.exports = __webpack_public_path__ + "footer.8502ad407b32e806713f.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/emrevolkanucar/Desktop/Angular/etigumus/src/assets/img/footer.jpg
// module id = ../../../../../src/assets/img/footer.jpg
// module chunks = main